import { render, staticRenderFns } from "./SectionCTA.vue?vue&type=template&id=09e58433&scoped=true"
import script from "./SectionCTA.vue?vue&type=script&lang=js"
export * from "./SectionCTA.vue?vue&type=script&lang=js"
import style0 from "./SectionCTA.vue?vue&type=style&index=0&id=09e58433&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e58433",
  null
  
)

export default component.exports